import {Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  ExcludedHospitalsSearchParam,
  GroupRegisterType,
  NchPointCheckHcodeExcludeDto,
  Page,
  YesNo
} from "../../../../../generated-model/model";
import {IgnoreNullHttpParams} from "../../../../shared/commons/Ignore-null-http-params";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {DecimalPipe} from "@angular/common";
import {
  HospitalAutocompleteComponent
} from "../../../../shared/components/hospital-autocomplete/hospital-autocomplete.component";
import {ExcludedHospitalsModalService} from "./modal/excluded-hospitals-modal.service";
import {ExcludedHospitalsResource} from "../../../../service/ExcludedHospitalsResource";
import {ThaiDateTimePipe} from "../../../../shared/commons/thai-datetime.pipe";
import {SelectZoneComponent} from "../../../../shared/components/select-zone/select-zone.component";
import {
  ProvinceAutocompleteComponent
} from "../../../../shared/components/province-autocomplete/province-autocomplete.component";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {filter} from "rxjs/operators";
import {ToastService} from "../../../../shared/commons/toast/toast-service";

@Component({
  selector: 'app-excluded-hospitals',
  standalone: true,
  imports: [
    FormsModule,
    GtNgDatepickerModule,
    NgbPagination,
    NotFoundComponent,
    ReactiveFormsModule,
    DecimalPipe,
    HospitalAutocompleteComponent,
    ThaiDateTimePipe,
    SelectZoneComponent,
    ProvinceAutocompleteComponent
  ],
  templateUrl: './excluded-hospitals.component.html',
  styleUrl: './excluded-hospitals.component.scss'
})
export class ExcludedHospitalsComponent implements OnInit {
  pageData: Page<NchPointCheckHcodeExcludeDto> = {size: 10};
  params = signal<ExcludedHospitalsSearchParam>({});
  modalService = inject(ExcludedHospitalsModalService);
  excludedHospitalsResource = inject(ExcludedHospitalsResource);
  protected readonly YesNo = YesNo;
  protected readonly GroupRegisterType = GroupRegisterType;
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly toastService = inject(ToastService);

  constructor() {
  }

  ngOnInit(): void {
    this.search();
    // this.add();
    // this.toastService.showSuccess('ลบข้อมูลเรียบร้อยแล้ว')
  }

  search(page: number = 1) {
    const param = IgnoreNullHttpParams.fromObject({
      ...this.params(),
      page: page - 1,
      size: this.pageData.size
    })
    this.excludedHospitalsResource.search(param)
      .subscribe(value => {
        this.pageData = value;
      });
  }

  add() {
    this.modalService.open("CREATE")
      .subscribe({
        complete: () => {
          this.search(this.pageData?.number + 1);
        }
      });
  }

  reset() {
    this.params().type = undefined;
    this.params().hospital = undefined;
    this.params().zone = undefined;
    this.params().province = undefined;
  }

  view(item: NchPointCheckHcodeExcludeDto) {
    this.modalService.open("VIEW", item)
      .subscribe(value => {
      });
  }

  remove(item: NchPointCheckHcodeExcludeDto) {
    this.confirmDialogService.open({content: 'ยืนยันการลบข้อมูล'})
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.excludedHospitalsResource.remove(item)
            .subscribe({
              next: e => {
                this.search(this.pageData?.number + 1);
                this.toastService.showSuccess('ลบข้อมูลเรียบร้อยแล้ว')
              },
              complete: () => {
              }
            });
        }
      });
  }
}
